import { instance as axios } from "../axios";
import JWT from 'jsonwebtoken';

const TABLE = '/formulario/';

// initial state
const state = {
    data: []
}

// getters
const getters = {
    getAll:(state)=>{
        return state.data;
    },
    getById: (state) => (id) => {
        if(!id) return;
        return state.data.find((el)=>{ return el.id_formulario == id})
    }
}

// actions
const actions = {

    get({ commit }) {
        return axios
            .get(TABLE)
            .then(res => {
                commit('setData', res.data.data || null)
            })
            .catch(err => {
                commit('setData', null)
            });
    },

    insert({ dispatch }, params) {
        
        return axios
            .post(TABLE, { ...params })
            .then(res => {
                if(!res.data.errors) {
                    dispatch('get');
                    return true;
                }
                else return false;
            })
            .catch(err => {
                return false;
            });
    },

    update({ dispatch }, params) {
        return axios
            .put(TABLE, { ...params })
            .then(res => {
                if(!res.data.errors) {
                    dispatch('get');
                    return true;
                }
                else return false;
            })
            .catch(err => {
                return false;
            });
    },

    delete({ dispatch }, {id}) {
        return axios
            .delete(TABLE+id)
            .then(res => {
                if(!res.data.errors){
                    dispatch('get');
                    return true;
                }
                else return false;
            })
            .catch(err => {
                return false;
            });
    },

}

// mutations
const mutations = {
    setData(state, data) {
        state.data = data ? data : [];
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/formularios.js